module.exports = __webpack_public_path__ + "static/media/ovest3.8b255dd0.svg";